import Container from "./Container";

export default function Section({ eyebrow, title, subtitle, children, pad = "py-14" }) {
  return (
    <section className={pad}>
      <Container>
        {(eyebrow || title || subtitle) && (
          <header className="mb-8">
            {eyebrow && <div className="text-xs uppercase tracking-wider text-rose-600 font-semibold">{eyebrow}</div>}
            {title && <h2 className="text-2xl md:text-3xl font-bold mt-1 text-slate-900">{title}</h2>}
            {subtitle && <p className="text-slate-600 mt-2 max-w-2xl">{subtitle}</p>}
          </header>
        )}
        {children}
      </Container>
    </section>
  );
}
